
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctOverlap as ObiDuctOverlapElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-overlap.js';
 
 
 

 
 export const ObiDuctOverlap = createComponent({
   react: React,
   tagName: 'obi-duct-overlap',
   elementClass: ObiDuctOverlapElement,
   events: {
     
   }
  });
 
 